import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleChevronDown } from "@fortawesome/free-solid-svg-icons";

function SolutionStep(props) {
  return (
    <div className="initiative-text-step">
      <p className="initiative-text-description">
        <span>
          <FontAwesomeIcon className="initiative-fa-icon" icon={faCircleChevronDown} />{" "}
          {props.description}
        </span>
      </p>
    </div>
  );
}

export default SolutionStep;
